import { z } from "zod";

import { AttachmentLike } from "@/data/attachments";
import { PhoneNumber } from "@/data/phones";

export const UserBase = z
  .object({
    id: z.number().nullish(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    email: z.string().nullish(),
    phone: PhoneNumber.nullish(),
    avatar: AttachmentLike.nullish(),
  })
  .passthrough();

export type UserBase = z.infer<typeof UserBase>;
